const TokenKey = 'znn-Token'
const UserInfoKey = 'znn-user-info-token'
const AppVersion = 'znn-version'
const AppVersionCode = 'znn-version-code'
const AppPackage = 'znn-app-package'
const AppPublicKey = 'znn-public-key'
const AppStoreName = 'znn-app-name-store'
export function getToken() {
  return localStorage.getItem(TokenKey)
}

export function setToken(token) {
  return localStorage.setItem(TokenKey, token)
}

// 设置一个公钥
export function setPublicKey(data) {
  return localStorage.setItem(AppPublicKey, data)
}

export function getPublicKey() {
  const getkey = localStorage.getItem(AppPublicKey)
  return getkey
}

export function removeToken() {
  return localStorage.removeItem(TokenKey)
}
export function getUserInfo() {
  const userInfo = localStorage.getItem(UserInfoKey)
  if (userInfo) {
    return JSON.parse(userInfo)
  }
  return null
}

export function setUserInfo(user) {
  return localStorage.setItem(UserInfoKey, JSON.stringify(user))
}

export function removeUserInfo() {
  return localStorage.removeItem(UserInfoKey)
}

export function setAppVersion(version) {
  return localStorage.setItem(AppVersion, version)
}

export function getAppVersion() {
  return localStorage.getItem(AppVersion)
}
export function setAppVersionCode(version) {
  return localStorage.setItem(AppVersionCode, version)
}

export function getAppVersionCode() {
  return localStorage.getItem(AppVersionCode)
}
export function setAppPackage(appPackage) {
  return localStorage.setItem(AppPackage, appPackage)
}

export function getAppPackage() {
  return localStorage.getItem(AppPackage)
}
export function setAppStoreName(storeName) {
  return localStorage.setItem(AppStoreName, storeName)
}
export function getAppStoreName() {
  return localStorage.getItem(AppStoreName)
}
